import { Stack, Typography } from "@mui/material";

import { ShipmentStatusEmptyState } from "components/ShipmentStatusEmptyState";
import { ISOStringToLocalReadableTimestamp } from "utils";

const SECTION_STYLE = {
  borderColor: "#cecdcd",
  borderWidth: "1px",
  borderStyle: "solid",
  borderRadius: 2,
  p: ".5rem",
};

interface Props {
  shipment: PublicShipment;
}

export function PublicShipmentStateDisplay(props: Props) {
  const { shipment } = props;

  let component = (
    <ShipmentStatusEmptyState subtitle="Pickup and delivery updates will appear here as the carrier reports them." />
  );

  if (shipment.shipment_status === "DELIVERED" && shipment.delivery != null) {
    component = (
      <Stack direction="column" spacing={1} sx={SECTION_STYLE}>
        <Typography>
          Shipment marked as{" "}
          <b>
            <u>delivered</u>
          </b>{" "}
          on {ISOStringToLocalReadableTimestamp(shipment.delivery.delivered_at)}
        </Typography>
        <Typography>
          Marked delivered by{" "}
          <b>{shipment.delivery.created_by.user.first_name}</b>{" "}
          <b>{shipment.delivery.created_by.user.last_name}</b>
        </Typography>
        {shipment.delivery.notes != null && shipment.delivery.notes !== "" && (
          <Typography>
            <b>{"Notes: "}</b>
            {shipment.delivery.notes}
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary">
          Delivered status created on{" "}
          {ISOStringToLocalReadableTimestamp(shipment.delivery.created_at)}
        </Typography>
      </Stack>
    );
  }

  if (
    shipment.shipment_status === "PICKED_UP" &&
    shipment.first_pickup != null
  ) {
    component = (
      <Stack direction="column" spacing={1} sx={SECTION_STYLE}>
        <Typography>
          Shipment marked as{" "}
          <b>
            <u>picked up</u>
          </b>{" "}
          on{" "}
          {ISOStringToLocalReadableTimestamp(
            shipment.first_pickup.picked_up_at,
          )}
        </Typography>
        <Typography>
          Marked picked up by{" "}
          <b>{shipment.first_pickup.created_by.user.first_name}</b>{" "}
          <b>{shipment.first_pickup.created_by.user.last_name}</b>
        </Typography>
        {shipment.first_pickup.notes != null &&
          shipment.first_pickup.notes !== "" && (
            <Typography>
              <b>{"Notes: "}</b>
              {shipment.first_pickup.notes}
            </Typography>
          )}
        <Typography variant="body2" color="text.secondary">
          Picked up status created on{" "}
          {ISOStringToLocalReadableTimestamp(shipment.first_pickup.created_at)}
        </Typography>
      </Stack>
    );
  }

  return <Stack mt="1rem">{component}</Stack>;
}
